import { createNextTableContext } from '@core/table';

export const FlightsTableContext = createNextTableContext();
